"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AlignmentList;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _alignments = require("../constants/alignments");

var _AlignmentButton = _interopRequireDefault(require("./AlignmentButton"));

function AlignmentList(props) {
  var alignment = props.alignment,
      onChangeAlignment = props.onChangeAlignment,
      i18nAlignmentKey = props.i18nAlignmentKey,
      showInlineAlignment = props.showInlineAlignment;
  var calculatedAlignmentValues = [_alignments.Alignments.LEFT, _alignments.Alignments.CENTER, _alignments.Alignments.RIGHT];

  if (showInlineAlignment) {
    calculatedAlignmentValues.unshift(_alignments.Alignments.NONE);
  }

  var handleAlignmentChange = function handleAlignmentChange(newAlignment) {
    onChangeAlignment(newAlignment, alignment);
  };

  return _react.default.createElement(_UIFlex.default, {
    justify: showInlineAlignment ? 'between' : 'start'
  }, calculatedAlignmentValues.map(function (value) {
    return _react.default.createElement(_AlignmentButton.default, {
      key: value,
      alignment: value,
      selected: alignment === value,
      tooltip: i18nAlignmentKey(value),
      onSelect: handleAlignmentChange
    });
  }));
}

AlignmentList.propTypes = {
  i18nAlignmentKey: _propTypes.default.func.isRequired,
  alignment: _propTypes.default.string.isRequired,
  onChangeAlignment: _propTypes.default.func.isRequired,
  showInlineAlignment: _propTypes.default.bool
};
AlignmentList.defaultProps = {
  showInlineAlignment: true
};
module.exports = exports.default;